import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5474208e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = ["src"]

import HackerText from '@/js/components/HackerText.vue'
import AnimatedSiteMapLocation from '@/js/components/AnimatedSiteMapLocation.vue'
import DashedArc from '@/js/components/DashedArc.vue'
import { ref } from 'vue'
import { useElementSize } from '@vueuse/core'

interface AnimatedSiteMapConfig {
  image: string
  referenceWidth: number
  referenceHeight: number
  texts: {
    text: string
    style: {
      [key: string]: string
    }
    delay?: number
  }[]
  locations: {
    text?: string
    style?: {
      [key: string]: string
    }
    delay?: number
    lineOneSize?: number
    lineTwoSize?: number
    rotation?: number
    mode?: 'toBottomRight' | 'toTopLeft'
  }[]
  arcs: {
    nLines?: number
    radius?: number
    delay?: number
    lineSize?: number
    style?: {
      [key: string]: string
    }
  }[]
}

interface Props {
  type: 'giant-magellan-telescope' | 'thirty-meter-telescope'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnimatedSiteMap',
  props: {
    type: null
  },
  setup(__props: any) {

const props = __props as {
  type: 'giant-magellan-telescope' | 'thirty-meter-telescope'
};

const GIANT_MAGELLAN_CONFIG: AnimatedSiteMapConfig = {
  image: '/static/images/giant-magellan-sitemap-base.jpg',
  referenceWidth: 1400,
  referenceHeight: 832,
  arcs: [
    {
      nLines: 80,
      radius: 120,
      style: {
        top: '50%',
        right: '20%',
      },
    },
  ],
  texts: [
    {
      text: 'GIANT MAGELLAN',
      style: {
        top: '20%',
        right: '7%',
        fontSize: '40px',
        fontWeight: 'bold',
      },
    },
    {
      text: 'TELESCOPE SITE',
      style: {
        top: '25%',
        right: '7%',
        fontSize: '40px',
        fontWeight: 'bold',
      },
    },
    {
      text: '• LAS CAMPANAS PEAK,',
      style: {
        top: '460px',
        right: '60px',
        fontSize: '35px',
      },
      delay: 2500,
    },
    {
      text: 'CHILE',
      style: {
        top: '500px',
        right: '338px',
        fontSize: '35px',
      },
      delay: 2500,
    },
    {
      text: 'ELEVATION: 2514 M',
      style: {
        top: '560px',
        right: '184px',
      },
      delay: 3500,
    },
    {
      text: '• SUMMIT OFFICES & SUPPORT',
      style: {
        top: '650px',
        right: '80px',
      },
      delay: 3500,
    },
    {
      text: 'SUPPORT BUILDINGS',
      style: {
        top: '680px',
        right: '185px',
      },
      delay: 3500,
    },
    {
      text: 'SUPPORT SITE 1',
      style: {
        top: '150px',
        left: '100px',
        fontWeight: 'bold',
      },
      delay: 7000,
    },
    {
      text: 'SUPPORT SITE 2',
      style: {
        top: '380px',
        left: '100px',
        fontWeight: 'bold',
      },
      delay: 7000,
    },
  ],
  locations: [
    {
      text: 'MAGELLAN TELESCOPES',
      style: {
        top: '9%',
        left: '46%',
      },
      delay: 5000,
      lineTwoSize: 50,
      mode: 'toBottomRight',
    },
    {
      text: 'LABS, WORKSHOPS',
      style: {
        top: '516px',
        left: '603px',
      },
      lineOneSize: 300,
      lineTwoSize: 260,
      delay: 6000,
    },
    {
      text: '68 DORM ROOM',
      style: {
        top: '604px',
        left: '506px',
      },
      lineOneSize: 160,
      lineTwoSize: 210,
      delay: 6000,
    },
    {
      text: 'KITCHEN DINING RECREATION',
      style: {
        top: '632px',
        left: '494px',
      },
      lineOneSize: 100,
      lineTwoSize: 217,
      delay: 6000,
    },
    {
      text: '24 ROOM DORM',
      style: {
        top: '651px',
        left: '480px',
      },
      lineOneSize: 40,
      lineTwoSize: 222,
      delay: 6000,
    },
  ],
}

const THIRTY_METER_TELESCOPE_CONFIG: AnimatedSiteMapConfig = {
  image: 'https://noirlab.edu/public/media/archives/images/publicationjpg/tmt-mk-site-CC.jpg',
  referenceWidth: 1400,
  referenceHeight: 875,
  arcs: [
    {
      nLines: 50,
      radius: 150,
      lineSize: 30,
      style: {
        top: '85%',
        left: '17%',
      },
    },
  ],
  locations: [],
  texts: [
    {
      text: 'THIRTY METER',
      style: {
        left: '6%',
        bottom: '40%',
        fontSize: '40px',
        fontWeight: 'bold',
      },
    },
    {
      text: 'TELESCOPE SITE',
      style: {
        left: '6%',
        bottom: '35%',
        fontSize: '40px',
        fontWeight: 'bold',
      },
    },
    {
      text: 'MAUNAKEA',
      style: {
        left: '70%',
        bottom: '35%',
        fontSize: '35px',
      },
      delay: 2000,
    },
    {
      text: 'HAWAIʻI',
      style: {
        left: '70%',
        bottom: '30%',
        fontSize: '35px',
      },
      delay: 2000,
    },
    {
      text: 'ELEVATION: 4012 M',
      style: {
        left: '70%',
        bottom: '18%',
      },
      delay: 3000,
    },
  ],
}



const config = props.type === 'giant-magellan-telescope' ? GIANT_MAGELLAN_CONFIG : THIRTY_METER_TELESCOPE_CONFIG
const image = ref(null)
const { width, height } = useElementSize(image)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      ref_key: "image",
      ref: image,
      src: _unref(config).image,
      alt: ""
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", {
      class: "animations-scale-preserver",
      style: _normalizeStyle({
        transform: `translate(-50%, -50%) scale(
          ${_unref(width) / _unref(config).referenceWidth},
          ${_unref(height) / _unref(config).referenceHeight}
        )`,
        width: `${_unref(config).referenceWidth}px`,
        height: `${_unref(config).referenceHeight}px`,
      })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).texts, (text) => {
        return (_openBlock(), _createBlock(HackerText, {
          text: text.text,
          style: _normalizeStyle(text.style),
          delay: text.delay,
          key: text.text,
          class: "hacker-text"
        }, null, 8 /* PROPS */, ["text", "style", "delay"]))
      }), 128 /* KEYED_FRAGMENT */)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).locations, (location) => {
        return (_openBlock(), _createBlock(AnimatedSiteMapLocation, {
          text: location.text,
          style: _normalizeStyle(location.style),
          delay: location.delay,
          mode: location.mode,
          lineOneSize: location.lineOneSize,
          lineTwoSize: location.lineTwoSize,
          key: location.text
        }, null, 8 /* PROPS */, ["text", "style", "delay", "mode", "lineOneSize", "lineTwoSize"]))
      }), 128 /* KEYED_FRAGMENT */)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).arcs, (arc, index) => {
        return (_openBlock(), _createBlock(DashedArc, {
          nLines: arc.nLines,
          radius: arc.radius,
          delay: arc.delay,
          lineSize: arc.lineSize,
          style: _normalizeStyle(arc.style),
          key: index
        }, null, 8 /* PROPS */, ["nLines", "radius", "delay", "lineSize", "style"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 4 /* STYLE */)
  ]))
}
}

})